// ForecastContext.tsx
import * as React from 'react';

export type ForecastConfig = {
  x: number | Date | null;  // cutoff
  axisId: string;           // x-axis id to read scale from
  actualOpacity?: number;   // for area
  forecastOpacity?: number; // for area
};

export const ForecastContext = React.createContext<ForecastConfig | null>(null);
export const useForecastConfig = () => React.useContext(ForecastContext);
